import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const ProcessMasterPopup = (props) => {
    return (
        <ModalBasic
            id="processMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Process master</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Process no</label>
                        <TextInput type='number'
                            id='processNo' name='processNo'
                            value={props.processObject.processNo}
                            handleChange={(event) => props.handleChange(event, 'processNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Process name</label>
                        <TextInput type='text'
                            id='processName' name='processName'
                            value={props.processObject.processName}
                            handleChange={(event) => props.handleChange(event, 'processName')}
                            className={props.validState?.error?.processName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Process description</label>
                        <TextInput type='text'
                            id='processDesc' name='processDesc'
                            value={props.processObject.processDesc}
                            handleChange={(event) => props.handleChange(event, 'processDesc')}
                            className={props.validState?.error?.processDesc !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.processObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}